import { combineReducers } from 'redux';
import layoutReducer from './layout/layoutState';
import authReducer from './auth/authState';
import crudReducer from './crud/crudState';
import payrollReducer from './payroll/payrollState';
import payrunReducer from './payrun/payrunState';
import salaryAdditionReducer from './salaryaddition/salaryAdditionState';
import salaryAdjustmentReducer from './salaryadjustment/salaryAdjustmentState';
import salaryDeductionReducer from './salarydeduction/salaryDeductionState';
import employeeReducer from './employee/employeeState';
import salaryReducer from './salary/salaryState';
import reportReducer from './report/reportState';
import holidayReducer from './holiday/holidayState';
import clientReducer from './client/clientState';
import chargeRateReducer from './chargerate/chargeRateState';
import finalPayReducer from './finalpay/finalPayState';
import optionlistReducer from './optionlist/optionlistState';
import accessRightReducer from './accessright/accessRightState';
import userReducer from './user/userState';
import accessGroupReducer from './accessgroup/accessGroupState';
import moduleReducer from './module/moduleState';
import accessGroupUserReducer from './accessgroupuser/accessGroupUserState';
import timeCardReducer from './timecard/timeCardState';
import leaveReducer from './leave/leaveState';
import overtimeReducer from './overtime/overtimeState';
import trainingModuleReducer from './trainingmodule/trainingModuleState';
import jobRoleReducer from './jobrole/jobRoleState';
import trainingModuleRequestReducer from './trainingmodulerequest/trainingModuleRequestState';
import trainingClassReducer from './trainingclass/trainingClassState';
import jobRoleRequestReducer from './jobrolerequest/jobRoleRequestState';
import overviewReducer from './overview/overviewState';
import awardReducer from './award/awardState';
import employeeAwardReducer from './employeeaward/employeeAwardState';
import jobPostReducer from './jobpost/jobPostState';
import trainingClassCertificationReducer from './trainingclasscertification/trainingClassCertificationState'
import faqReducer from './faq/faqState';
import recruitmentReducer from './recruitment/recruitmentState';
import rewardReducer from './reward/rewardState';
import employeeRewardReducer from './employeereward/employeeRewardState';
import recognitionWallReducer from './recognitionwall/recognitionWallState'
import userReactionReducer from './userreaction/userReactionState';
import ticketReducer from './supportticket/supportticketState';
import ticketReplyReducer from './ticketreply/ticketreplyState';
import documentReducer from './document/documentState';
import copilotReducer from './copilot/copilotState';

const rootReducer = combineReducers({
	layout: layoutReducer,
  	auth: authReducer,
  	crud: crudReducer,
  	employee: employeeReducer,
  	payroll: payrollReducer,
  	payrun: payrunReducer,
  	salaryAddition: salaryAdditionReducer,
  	salaryAdjustment: salaryAdjustmentReducer,
  	salaryDeduction: salaryDeductionReducer,
  	salary: salaryReducer,
  	report: reportReducer,
  	holiday: holidayReducer,
  	client: clientReducer,
  	chargeRate: chargeRateReducer,
	finalPay: finalPayReducer,
	optionlist: optionlistReducer,
	accessRight: accessRightReducer,
	user: userReducer,
	accessGroup: accessGroupReducer,
	module: moduleReducer,
	accessGroupUser: accessGroupUserReducer,
	timeCard: timeCardReducer,
	leave: leaveReducer,
	overtime: overtimeReducer,
	trainingModule: trainingModuleReducer,
	jobRole: jobRoleReducer,
	trainingModuleRequest: trainingModuleRequestReducer,
	trainingClass: trainingClassReducer,
	jobRoleRequest: jobRoleRequestReducer,
	overview: overviewReducer,
	award: awardReducer,
	employeeAward: employeeAwardReducer,
	jobPost:jobPostReducer,
	trainingClassCertification: trainingClassCertificationReducer,
	faq: faqReducer,
	recruitment: recruitmentReducer,
	reward: rewardReducer,
	employeeReward: employeeRewardReducer,
	recognitionWall: recognitionWallReducer,
	userReaction: userReactionReducer,
	ticket: ticketReducer,
	ticketReply: ticketReplyReducer,
	document: documentReducer,
	copilot: copilotReducer,
});

export default rootReducer;
